import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: "1", text: "通常", enum: "NOMAL" },
  { value: "2", text: "委託・消化仕入", enum: "CONSIGNMENT" },
]);
